import { useQuery } from '@tanstack/react-query';
import { QuoteMoratoriumGetResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { QuoteMoratoriumKey } from '@services/moratorium/keys';

const config = {
  staleTime: 300000,
};

export const useSearchMoratoriums = (quoteId?: string) => {
  const client = useClient();

  const result = useQuery<QuoteMoratoriumGetResponse, Error>({
    queryKey: QuoteMoratoriumKey.get(quoteId),
    queryFn: async () => client.get(`quote/${quoteId}/moratorium`).json<QuoteMoratoriumGetResponse>(),
    enabled: !!quoteId,
    ...config,
  });

  return { ...result, moratoriums: result.data?.items || [] };
};
